import { render, staticRenderFns } from "./PackageTab.vue?vue&type=template&id=22bd4172"
import script from "./PackageTab.vue?vue&type=script&lang=js"
export * from "./PackageTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports